<template>
	<ListDetailLayout
			:store="firmwaresStore"
      index-route-name="admin.firmware"
			create-permissions="create:firmwares"
			@on-create="$router.push({ name: 'admin.firmware.firmware', params: { firmware: 'NEW' } })"
			@on-paginate="(page) => useOnPaginate(page, refreshFirmwares, params)"
			@on-search="(page) => useOnSearch(page, refreshFirmwares, params)"
      :filter="params.filter"
      @on-filter="({ filter }) => useOnFilter(filter, refreshFirmwares, params)"
	  create-button-admin-page="create-firmware-btn"
	  search-admin-page="search-firmware-admin-page"
	>

		<template #list>
			<li v-for="firmware in firmwaresStore.getFirmwares" :key="firmware.id">
				<router-link :to="{ name: 'admin.firmware.firmware', params: { firmware: firmware.id } }" v-slot="{isActive}">
					<div
							:class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

						<div class="min-w-0 flex flex-row w-full items-start justify-between">
							<div class="flex-1">
								<div class="flex items-start gap-x-3">
									<p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">
										{{ firmware.version_number }}</p>
								</div>
								<div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
                  <p class="whitespace-nowrap">
                    {{ firmware.device_type?.name || '-' }} / {{ firmware.device_model?.name || '-' }}
                  </p>
								</div>
							</div>
							<div class="flex flex-col items-end space-y-1">
								<div class="text-sm text-surface-600 dark:text-surface-500">{{ useFilesize(firmware.size_bytes) }}</div>

								<IconAlertTriangleFilled v-if="!firmware.release_notes_count || !firmware.testing_documents_count"
								                         class="text-yellow-400 h-5 w-5"/>
							</div>
						</div>

					</div>
				</router-link>
			</li>
		</template>

		<template #detail>
			<router-view v-if="$route.params.firmware" @on-save="refreshFirmwares"
			             @on-delete="refreshFirmwares"></router-view>
		</template>

	</ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import { useFirmwaresStore } from "@/stores/firmwares.js";
import { useFilesize } from "@/Composables/Filesize.js";
import { IconAlertTriangleFilled } from "@tabler/icons-vue";
import {useOnFilter, useOnPaginate, useOnSearch} from "@/Composables/Pagination.js";

export default {
	name: "FirmwareIndex",
	data() {
		return {
			params: {
				include: [
          'deviceModel',
          'deviceType',
					'releaseNotesCount',
					'testingDocumentsCount',
				],
        filter: {
          firmware_type_ids: [],
          device_type_ids: [],
          device_model_ids: [],
          device_revision_ids: [],
          regulation_ids: [],
        }
			}
		}
	},
	methods: {
    useOnFilter,
		useFilesize,
		useOnPaginate,
		useOnSearch,
		refreshFirmwares() {
			return this.firmwaresStore.indexFirmwares(this.params)
		}
	},
	components: {Container, ListDetailLayout, IconAlertTriangleFilled},
	computed: {
		...mapStores(useFirmwaresStore)
	},
	async mounted() {
		await this.refreshFirmwares();
	}
}
</script>